<template>
    <ol
        id="tabs"
        ref="list"
        class="container flex overflow-scroll border-b container--sm-up border-grey-100"
    >
        <li
            v-for="(step, i) in steps"
            :id="'step-' + i"
            :key="i"
            class="pt-1 pb-3 pl-5 border-r cursor-pointer md:pb-5 pr-14 border-grey-100"
            :class="[
                i == activeStep ? 'text-blue-500 border-b-4' : 'text-grey-500',
                { 'border-l': i == 0 }
            ]"
            style="border-bottom-color: #ffc749;"
            @click="stepTo(i)"
        >
            <p class="mb-1">{{ i + 1 }}</p>
            <p>{{ step }}</p>
        </li>
    </ol>
</template>

<script>
export default {
    props: {
        activeStep: {
            type: Number,
            required: true
        },
        steps: {
            type: Array,
            required: true
        }
    },

    watch: {
        activeStep() {
            this.$refs.list.scrollTo({
                top: 0,
                left: 130 * this.activeStep,
                behavior: 'smooth'
            });
        }
    },

    methods: {
        stepTo(step) {
            if (step < this.activeStep) {
                this.$emit('step-to', step);
            }
        }
    }
};
</script>
<style>
#tabs::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}
#tabs {
    scrollbar-width: none;
}
</style>
